import { Injectable } from "@angular/core";
import { AuthenticationGuard } from "@app/auth/authentication.guard";
import { HomeComponent } from "@app/home/home.component";
import { LoggerService } from "@app/logger/logger.service";
import { MicrofrontendHostComponent } from "@app/microfrontend-host/microfrontend-host.component";
import { NavigationComponent } from "./navigation.component";
import { environment } from "@env/environment";


import { Routes } from "@angular/router";


const log = new LoggerService('NAVIGATION SERVICE');


@Injectable({ providedIn: "root" })
export class NavigationService {

  constructor() { }

  public navigationData: Navigation.NavigationData[] = [];
  public navigationRoutes: Navigation.NavigationGeneratedRoute[] = [];
  public routerConfiguration: Routes = [];
  public homeNavigationRoutes: Navigation.NavigationGeneratedRoute[] = [];


  /**
   * @description Adquiere la información de las rutas del usuario y genera la configuración de las rutas para el Router Module.
   * @returns Router config.
   */
  public async startupNavigationService({ isLoggedIn }: { isLoggedIn: boolean }) {
    //log.debug('Starting navigation service...');
    if (!isLoggedIn) {
      this.navigationData = []
    } else {
      this.navigationData = await this.getNavigationData();
    }

    //log.debug('Navigation data:', this.navigationData);

    this.navigationRoutes = await this.generateNavigationRoutes();
    //log.debug('Navigation routes:', this.navigationRoutes);
    this.routerConfiguration = this.generateRouterConfiguration();
    //log.debug('Navigation newRouterconfig:', this.routerConfiguration);
  }

  /**
   * @description Adquiere los datos de navegación correspondientes para el usuario que inicia sesión en la plataforma.
   * @todo Implementación real con el backend.
   * @returns 'NavigationData' El objeto json de los tados de navegación.
   */
  private async getNavigationData(): Promise<Navigation.NavigationData[]> {

    //if (!this.authenticationService.isLoggedIn()) return [];
    const userData = await this.findUserInDatabase();
    //log.debug('User found ', userData);

    const navData = this.filterNavigationRoutes(userData);
    //log.debug('navData: ', navData)

    return navData;

  }

  /**
   * @description Filtra los datos de navegación de los usuarios 
   * @param userData 
   */
  private filterNavigationRoutes(userData: Entities.Custom.UserWithOrgsAndRoles): Navigation.NavigationData[] {
    const userOrgs = Object.keys(userData.organizations);
    //log.debug('[filterNavigationRoutes] userOrgs: ', userOrgs);
    if (userOrgs.length === 0) {
      //log.info('[TODO]: implementar ruta predeterminada para usuario no asignado a organizaciones.');
      throw new Error('El usuario no cuenta con nignuna organización. El frontend espera una.')
    }


    if (userOrgs.length > 0) {
      
      let navTreeArray = [];
      let epioneGeneralNavAccessTree:any = {};

      for (let i = 0; i < userOrgs.length; i++) {
        const currentOrg = userData.organizations[userOrgs[i]];

        if (currentOrg.roles.length === 0) continue;
        if (currentOrg.roles.length === 1) {
          //log.debug('[filterNavigationRoutes]  SOLO UN ROL ENCONTRADO PARA LA ORGANIZACIÓN: ');
          const isEpioneGeneral = currentOrg.roles[0].navAccessTree.remoteEntry === 'MF_EPIONE_GENERAL';
          //log.debug('[filterNavigationRoutes]  Role is epione genearl: ', isEpioneGeneral);

          if (isEpioneGeneral) {
            epioneGeneralNavAccessTree = currentOrg.roles[0].navAccessTree;
            epioneGeneralNavAccessTree.organization = currentOrg.id;
            epioneGeneralNavAccessTree.logo = currentOrg.logo;
            //log.debug('[filterNavigationRoutes] currentOrg: ', currentOrg);
            //log.debug('[filterNavigationRoutes] epioneGeneralNavAccessTree: ', epioneGeneralNavAccessTree);
          }
          else{
            const newNavTree = currentOrg.roles[0].navAccessTree;
            newNavTree.organization = currentOrg.id;
            newNavTree.logo = currentOrg.logo;
            //log.debug('[filterNavigationRoutes] currentOrg: ', currentOrg);
            //log.debug('[filterNavigationRoutes] newNavTree: ', newNavTree);
            navTreeArray.push(newNavTree);
          }

        }

        if (currentOrg.roles.length > 1) {
          //log.debug('[filterNavigationRoutes]  VARIOS ROLES ENCONTRADOS PARA LA ORGANIZACIÓN: ');

          //log.debug('[filterNavigationRoutes]  Many roles in org: ', currentOrg.roles.length);

          let epioneGeneralJsonRoutes = {};
          let microfrontendJsonRoutes = {};

          for (let x = 0; x < currentOrg.roles.length; x++){
            const isEpioneGeneral = currentOrg.roles[x].navAccessTree.remoteEntry === 'MF_EPIONE_GENERAL';
            const currentRoutes = currentOrg.roles[x].navAccessTree.routes;
            //log.debug('[filterNavigationRoutes]  Role is epione genearl: ', isEpioneGeneral);
  
            if (isEpioneGeneral){
              epioneGeneralJsonRoutes = { ...epioneGeneralJsonRoutes, ...this.convertRoutesArrayToJson(currentRoutes) }
              //log.debug('[filterNavigationRoutes] epioneGeneralJsonRoutes: ', epioneGeneralJsonRoutes);

              if (x === currentOrg.roles.length - 1){
                //log.debug('[filterNavigationRoutes] epioneGeneralNavAccessTree.routes: ', epioneGeneralNavAccessTree);
                epioneGeneralNavAccessTree = currentOrg.roles[x].navAccessTree;
                epioneGeneralNavAccessTree.organization = currentOrg.id;
                epioneGeneralNavAccessTree.logo = currentOrg.logo;
                epioneGeneralNavAccessTree.routes = this.convertRoutesJsonToArray(epioneGeneralJsonRoutes);
                //log.debug('[filterNavigationRoutes] currentOrg: ', currentOrg);
                //log.debug('[filterNavigationRoutes] epioneGeneralNavAccessTree: ', epioneGeneralNavAccessTree);
              }
            }
            else {
              microfrontendJsonRoutes = { ...microfrontendJsonRoutes, ...this.convertRoutesArrayToJson(currentRoutes) }
              //log.debug('[filterNavigationRoutes] microfrontendJsonRoutes: ', microfrontendJsonRoutes);

              if (x === currentOrg.roles.length - 1){
                const orgNavMergedTree = currentOrg.roles[x].navAccessTree;
                orgNavMergedTree.organization = currentOrg.id;
                orgNavMergedTree.logo = currentOrg.logo;
                orgNavMergedTree.routes = this.convertRoutesJsonToArray(microfrontendJsonRoutes);
                //log.debug('[filterNavigationRoutes] currentOrg: ', currentOrg);
                //log.debug('[filterNavigationRoutes] orgNavMergedTree: ', orgNavMergedTree);
                navTreeArray.push(orgNavMergedTree);
              }
            }
          }
        }
      }

      //log.debug('Arreglo de arbol final de rutas para usuario: ', navTreeArray)
      /** Solo será igual a 1 si el usuario cuenta con solo 2 organizaciones siendo una de ellas Epione General */
     
      if (epioneGeneralNavAccessTree && Object.keys(epioneGeneralNavAccessTree).length !== 0) 
        navTreeArray.push(epioneGeneralNavAccessTree);

      if (navTreeArray.length === 0)
        throw new Error('Error al generar el arbol de navegación del usuario, asegúrate que tiene organizaciones y roles asignados.')
      return navTreeArray;
    }
  }

  /**
   * @description Función utilizada para convertir json a los arreglos de rutas. Funciona de forma recursiva para convertir los arreglos de rutas anidados.
   * @param jsonRoutes Las rutas de navegación a convertir.
   * @returns routes
   */
  private convertRoutesJsonToArray(jsonRoutes:any) {
    //log.debug('[convertRoutesJsonToArray] jsonroutes: ', jsonRoutes);
    const keys = Object.keys(jsonRoutes);

    let routesArray = [];

    for (let x=0; x< keys.length; x++) {
      const currentJsonObj = jsonRoutes[keys[x]]
      //log.debug('[convertRoutesJsonToArray] currentJsonObj: ', currentJsonObj)
      
      if(Object.keys(currentJsonObj.children).length === 0) {
        currentJsonObj.children = [];

      } else { 
        currentJsonObj.children =  this.convertRoutesJsonToArray(currentJsonObj.children)
      }

      routesArray.push(currentJsonObj);
    }
    return routesArray;
  }

  /**
   * @description Función utilizada para convertir a json los arreglos de rutas. Funciona de forma recursiva para convertir los arreglos de rutas anidados.
   * @param array Las rutas de navegación a convertir.
   * @returns Json routes
   */
  private convertRoutesArrayToJson(array: Array<Navigation.NavigationDataRoute>){

    let jsonRoutes = {};
    
    for (let x = 0; x < array.length; x++){
      const currentRoute = array[x];

      jsonRoutes[currentRoute.path] = {
        children: {},
        componentName: currentRoute.componentName,
        icon: currentRoute.icon,
        name: currentRoute.name,
        path: currentRoute.path
      };

      if (currentRoute.children.length > 0) {
        jsonRoutes[currentRoute.path] = {
          children: this.convertRoutesArrayToJson(currentRoute.children),
          componentName: currentRoute.componentName,
          icon: currentRoute.icon,
          name: currentRoute.name,
          path: currentRoute.path
        };
      }
    }
    return jsonRoutes;
  }


  /**
   * @description Adquiere la información completa del usuario de la base de datos.
   */
  private async findUserInDatabase() {
    //log.debug('Local storage: ', localStorage);
    const idToken = localStorage.getItem('idToken');
    const userId = localStorage.getItem('userId');
    if (!userId) {
      throw new Error('Usuario no encontrado en el local storage');
    }
    const response = await fetch(`${environment['EPIONE_API']}/epione-core-api/users/roles/${userId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Berear ${idToken}`
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const data = (await response.json()).data[0]
    //log.debug('Find user Response: ', data);

    return data;
  }

  /**
   * @description Genera las rutas de navegación utilizando el objeto 'NavigationData'.
   * @returns Arreglo de rutas de navegación 'NavigationGeneratedRoute[]'.
   */
  private async generateNavigationRoutes(): Promise<Navigation.NavigationGeneratedRoute[]> {
    if (this.navigationData.length === 0)
      return;

    let routes: Navigation.NavigationGeneratedRoute[] = [];
    for (let i = 0; i < this.navigationData.length; i++) {
      routes = [...routes, ...this.recursiveRouteGenerator(this.navigationData[i].remoteEntry, this.navigationData[i].exposedModule, this.navigationData[i].routes)]
    }
    return routes;
  }


  /**
   * @description Genera las configuración del router de angular con las rutas dinámicas creadas por el servicio.
   * @returns Router configuration.
   */
  private generateRouterConfiguration() {
    return [
      {
        path: 'home',
        component: HomeComponent,
        children:
          [
            {
              path: 'login',
              loadChildren: () => import('@app/login-dialog/login-dialog.module').then(m => m['LoginDialogModule']),
            },
            ...this.homeNavigationRoutes
          ]
      },
      {
        path: '',
        component: NavigationComponent,
        canActivate: [AuthenticationGuard],
        children: this.navigationRoutes
      },
      {
        path: '**',
        redirectTo: ''
      },
    ]
  }


  /**
   * 
   * @description Función que analiza un objeto del arreglo de ToolsData y contruye todas las rutas anidadas correspondientes para cada herramienta anidada.
   * @param remoteEntry El punto de entrada del micro frontend. Adquirido de un opbjeto del arreglo de NavigationData.
   * @param exposedModule El modulo expuesto del micro frontend. Adquirido de un opbjeto del arreglo de NavigationData.
   * @param tools El arreglo de 'Entities.Tools.ToolsData' por analizar
   * @returns NavigationDataRoute[]
   */
  public generateNavigationDataRoutesFromToolsArray(remoteEntry: string, exposedModule: string, tools: Entities.Tool.ToolData[]): Navigation.NavigationDataRoute[] {
    const navDataRoutesGenerated: Navigation.NavigationDataRoute[] = []
    for (let i = 0; i < tools.length; i++) {
      if (tools[i].tools.length === 0) {
        const navDataRoute: Navigation.NavigationDataRoute = {
          name: tools[i].name,
          path: tools[i].path,
          componentName: tools[i].componentName,
          icon: tools[i].favicon,
          children: []
        }
        navDataRoutesGenerated.push(navDataRoute);
      } else {
        const navDataRoute: Navigation.NavigationDataRoute = {
          name: tools[i].name,
          path: tools[i].path,
          componentName: tools[i].componentName,
          icon: tools[i].favicon,
          children: this.generateNavigationDataRoutesFromToolsArray(remoteEntry,exposedModule, tools[i].tools)
        }
        navDataRoutesGenerated.push(navDataRoute);
      }
    }
    return navDataRoutesGenerated;
  }




  /**
   * @description Función que analiza un objeto del arreglo de NavigationData y contruye todas las rutas anidadas si es que existen.
   * @param remoteEntry El punto de entrada del micro frontend. Adquirido de un opbjeto del arreglo de NavigationData.
   * @param exposedModule El modulo expuesto del micro frontend. Adquirido de un opbjeto del arreglo de NavigationData.
   * @param children El arreglo de 'NavigationDataRoute' por analizar
   * @returns NavigationGeneratedRoute[]
   */
  public recursiveRouteGenerator(remoteEntry: string, exposedModule: string, children: Navigation.NavigationDataRoute[]): Navigation.NavigationGeneratedRoute[] {
    const routesGenerated: Navigation.NavigationGeneratedRoute[] = [];
    for (let i = 0; i < children.length; i++) {

      if (children[i].children.length === 0) {
        const route: Navigation.NavigationGeneratedRoute = {
          path: children[i].path,
          component: MicrofrontendHostComponent,
          data: {
            remoteEntry: remoteEntry,
            exposedModule: exposedModule,
            componentName: children[i].componentName
          }
        };
        routesGenerated.push(route);
      } else {
        const routeWithChildren: Navigation.NavigationGeneratedRoute = {
          path: children[i].path,
          component: MicrofrontendHostComponent,
          data: {
            remoteEntry: remoteEntry,
            exposedModule: exposedModule,
            componentName: children[i].componentName
          },
          children: this.recursiveRouteGenerator(remoteEntry, exposedModule, children[i].children)
        }
        routesGenerated.push(routeWithChildren);
      }
    }

    return routesGenerated;
  }
}